import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Scientific from "@/components/landing/Scientific";
import Protocols from "@/components/landing/Protocols";
import LeadForm from "@/components/landing/LeadForm";
import Footer from "@/components/landing/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (target) =>
    lenisRef.current?.scrollTo(target, { offset: -72, duration: 1.4 });

  return (
    <div className="bg-ink min-h-screen font-sans">
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#16161C",
            border: "1px solid rgba(255,85,0,0.4)",
            color: "#fff",
          },
        }}
      />
      <Nav scrollTo={scrollTo} />
      <main>
        <Hero scrollTo={scrollTo} />
        <Marquee />
        <Scientific />
        <Protocols />
        <LeadForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
